/** Texto para comparar e buscar: o mesmo critério no TS (core e web) e no SQL. */

const percentual = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 });

/** Recebe pontos percentuais (1.35 → "1,35%"). */
export const formatarPercentual = (valor: number) => `${percentual.format(valor)}%`;

/** Sem acento e em minúsculas: "São João" e "sao joao" casam. */
export const semAcento = (t: string) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

/** As letras acentuadas do português e a troca de cada uma, para o `translate` do SQL fazer o que `semAcento` faz. */
export const ACENTOS = 'ÁÀÂÃÄÉÈÊËÍÌÎÏÓÒÔÕÖÚÙÛÜÇÑáàâãäéèêëíìîïóòôõöúùûüçñ';
export const SEM_ACENTOS = 'AAAAAEEEEIIIIOOOOOUUUUCNaaaaaeeeeiiiiooooouuuucn';

/** Um nome para arquivo baixado: sem acento, minúsculas e hífen no lugar do resto. */
export const nomeDeArquivo = (t: string) => semAcento(t).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
